export default "__VITE_ASSET__CAiTxKIC__"